import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import Tooltip from '../UI/Tooltip';
import { useCheckoutFlow } from '../../hooks/useCheckoutFlow';
import './pricingtable.css';
import CommonHeader from '../Headers/CommonHeader';
import { useNavigate } from 'react-router-dom';
import Modal from 'react-modal';
import Login from '../../modules/login/Login';
import { userAppContext } from '../../context/Context';
import { useAcademicApplication } from '../../hooks/useAcademicApplication';
import AcademicApplicationModal from '../Academic/AcademicApplicationModal';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'transparent',
    border: 'none',
  },
};

function PricingTablesAcademic() {
  const navigate = useNavigate();
  const { isAuthenticated, user } = userAppContext();
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showModalAcademic, setShowModalAcademic] = useState(false);
  const { redirectToCheckout } = useCheckoutFlow();
  const isStandard = user?.['cognito:groups']?.includes('ROLE_STANDARD');
  const isAdvanced = user?.['cognito:groups']?.includes('ROLE_PROFESSIONAL');

  // Use custom hook for academic application logic
  const {
    trialType,
    academicStatus,
    submitAcademicApplication,
    loadingStatus,
    canSeePrices: canSeePricesFromHook,
    isCommercial: isCommercialFromHook,
  } = useAcademicApplication(user?.email, isAuthenticated);

  // Use tag-based logic from hook
  const canSeePrices = canSeePricesFromHook();
  const isCommercialList = trialType === 'commercial' || isCommercialFromHook();

  const handleUpgradeClick = (planName, priceId) => {
    if (!isAuthenticated) {
      setShowLoginModal(true);
    } else {
      redirectToCheckout({ title: planName, priceId });
    }
  };

  const handleLoginSuccess = () => {
    setShowLoginModal(false);
  };

  const handleApplyToAcademicClick = () => setShowModalAcademic(true);

  // Show loader while data is loading
  if (isAuthenticated && loadingStatus) {
    return (
      <React.Fragment>
        <Helmet>
          <title>DISGENET: Academic Plans</title>
          <meta name="description" content="Explore DISGENET academic pricing plans." />
        </Helmet>
        <CommonHeader />
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <Helmet>
        <title>DISGENET: Academic Plans</title>
        <meta name="description" content="Explore DISGENET academic pricing plans." />
      </Helmet>
      <CommonHeader />
      <div>
        <div className="ml-80 mt-4 flex items-center gap-6">
          <p className="flex items-center gap-2">
            <i className="bi bi-x-circle-fill x-circle"></i>
            No data access
          </p>
          <p className="flex items-center gap-2">
            <i className="bi bi-check-circle-fill check-green"></i>
            Full data access
          </p>
        </div>
        <table
          className="table panther-table table-edit sticky"
          style={{ margin: '10px auto 10px', width: '70%', textAlign: 'center' }}
        >
          <thead>
            <tr className="table-titles">
              <th></th>
              <th>STANDARD</th>
              <th>ADVANCED</th>
            </tr>
          </thead>

          <tbody>
            {isAuthenticated && canSeePrices && (
              <tr>
                <td>
                  <span className="table-subsubtitles "></span>
                </td>
                <td className="grid">
                  <div>
                    <span className="font-bold text-2xl">99.92</span>
                    <small>€/mo</small>
                  </div>
                  <span>
                    <small>(1,199€ billed yearly)</small>
                  </span>
                </td>
                <td>
                  <div>
                    <span className="font-bold text-2xl">166.58</span>
                    <small>€/mo</small>
                  </div>
                  <span>
                    <small>(1,999€ billed yearly)</small>
                  </span>
                </td>
              </tr>
            )}
            {isAuthenticated && !canSeePrices && (
              <tr>
                <td>
                  <span className="table-subsubtitles "></span>
                </td>
                <td className="grid">
                  <p className="text-xl font-semibold" style={{ opacity: 0.8 }}>
                    Contact us for pricing
                  </p>
                </td>
                <td>
                  <p className="text-xl font-semibold" style={{ opacity: 0.8 }}>
                    Contact us for pricing
                  </p>
                </td>
              </tr>
            )}
            <tr>
              <td>
                <span className="table-subsubtitles">Full database access</span>
              </td>
              <td>
                <i className="bi bi-check-circle-fill check-green"></i>
              </td>
              <td>
                <i className="bi bi-check-circle-fill check-green"></i>
              </td>
            </tr>
            <tr>
              <td>
                <span className="table-subsubtitles">Full feature access</span>
              </td>
              <td>
                <i className="bi bi-check-circle-fill check-green"></i>
              </td>
              <td>
                <i className="bi bi-check-circle-fill check-green"></i>
              </td>
            </tr>
            <tr>
              <td>
                <span className="table-subsubtitles">Web platform</span>
              </td>
              <td>
                <i className="bi bi-check-circle-fill check-green"></i>
              </td>
              <td>
                <i className="bi bi-check-circle-fill check-green"></i>
              </td>
            </tr>
            <tr>
              <td>
                <span className="table-subsubtitles">REST-API </span>
              </td>
              <td>
                <i className="bi bi-x-circle-fill x-circle"></i>
              </td>
              <td>
                <i className="bi bi-check-circle-fill check-green"></i>
              </td>
            </tr>
            <tr>
              <td>
                {' '}
                <a href="https://gitlab.com/medbio/disgenet2r" target="_blank" rel="noopener noreferrer">
                  <u className="table-subsubtitles" style={{ color: ' #52B7DB' }}>
                    R package
                  </u>
                </a>
              </td>
              <td>
                <i className="bi bi-x-circle-fill x-circle"></i>
              </td>
              <td>
                <i className="bi bi-check-circle-fill check-green"></i>
              </td>
            </tr>
            <tr>
              <td>
                {' '}
                <a
                  href="https://apps.cytoscape.org/apps/disgenetapp"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <u className="table-subsubtitles" style={{ color: ' #52B7DB' }}>
                    Cytoscape App
                  </u>
                </a>
              </td>
              <td>
                <i className="bi bi-x-circle-fill x-circle"></i>
              </td>
              <td>
                <i className="bi bi-check-circle-fill check-green"></i>
              </td>
            </tr>
            <tr>
              <td>
                <span className="table-subsubtitles">
                  AIDA{' '}
                  <Tooltip content="Ask questions about the data in plain text—no coding needed" allowCopy={false} placement="top">
                    <i className="bi bi-info-circle"></i>
                  </Tooltip>
                </span>
              </td>
              <td>
                <i className="bi bi-check-circle-fill check-green"></i>
              </td>
              <td>
                <i className="bi bi-check-circle-fill check-green"></i>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td></td>
              {isCommercialList ? (
                <>
                  <td>
                    <button onClick={() => navigate('/Support')} className="btn-gradient-pink">
                      Contact Us
                    </button>
                  </td>
                  <td>
                    <button onClick={() => navigate('/Support')} className="btn-gradient-pink">
                      Contact Us
                    </button>
                  </td>
                </>
              ) : (
                <>
                  <td>
                    {trialType !== null && (!isStandard || !isAdvanced) ? (
                      trialType === 'commercial' ? (
                        <button
                          className="btn-gradient-pink"
                          disabled
                          style={{
                            opacity: 0.5,
                            cursor: 'not-allowed',
                          }}
                        >
                          Get Standard
                        </button>
                      ) : (
                        <Tooltip content="Apply for the Free Academic Plan below to access paid plans" allowCopy={false} placement="top">
                          <button
                            className="btn-gradient-pink"
                            disabled
                            style={{
                              opacity: 0.5,
                              cursor: 'not-allowed',
                            }}
                          >
                            Get Standard
                          </button>
                        </Tooltip>
                      )
                    ) : !isStandard ? (
                      <button
                        onClick={() =>
                          handleUpgradeClick(
                            'Standard',
                            process.env.REACT_APP_STRIPE_STANDARD_PRICE_ID ||
                              'price_1SCebx2Ml6stFA0rHcXCPwNj',
                          )
                        }
                        className="btn-gradient-pink"
                      >
                        Get Standard
                      </button>
                    ) : (
                      <button
                        disabled
                        className="btn-gradient-pink"
                        style={{
                          opacity: 0.5,
                          cursor: 'not-allowed',
                        }}
                      >
                        Current Plan
                      </button>
                    )}
                  </td>
                  <td>
                    {trialType !== null && (!isStandard || !isAdvanced) ? (
                      trialType === 'commercial' ? (
                        <button
                          className="btn-gradient-pink"
                          disabled
                          style={{
                            opacity: 0.5,
                            cursor: 'not-allowed',
                          }}
                        >
                          Get Advanced
                        </button>
                      ) : (
                        <Tooltip content="Apply for the Free Academic Plan below to access paid plans" allowCopy={false} placement="top">
                          <button
                            className="btn-gradient-pink"
                            disabled
                            style={{
                              opacity: 0.5,
                              cursor: 'not-allowed',
                            }}
                          >
                            Get Advanced
                          </button>
                        </Tooltip>
                      )
                    ) : !isAdvanced ? (
                      <button
                        onClick={() =>
                          handleUpgradeClick(
                            'Advanced',
                            process.env.REACT_APP_STRIPE_ADVANCED_PRICE_ID ||
                              'price_1SPPcK2Ml6stFA0rOiXzsUUM',
                          )
                        }
                        className="btn-gradient-pink"
                      >
                        Get Advanced
                      </button>
                    ) : (
                      <button
                        disabled
                        className="btn-gradient-pink"
                        style={{
                          opacity: 0.5,
                          cursor: 'not-allowed',
                        }}
                      >
                        Current Plan
                      </button>
                    )}
                  </td>
                </>
              )}
            </tr>
          </tfoot>
        </table>
        {trialType !== null && !isCommercialList && trialType !== 'commercial' && (
          <div className="text-center" style={{ marginTop: '20px' }}>
            {academicStatus === 'pending' ? (
              <p className="text-muted">Your academic application is pending approval</p>
            ) : academicStatus === 'approved' ? (
              <p className="text-muted">Your academic application has been approved</p>
            ) : (
              <button className="btn-gradient-blue" onClick={handleApplyToAcademicClick}>
                Apply for Free Academic Plan
              </button>
            )}
          </div>
        )}
        <div className="text-center">
          <button onClick={() => navigate('/plans')} className="mt-2 mb-6 underline">
            View more details
          </button>
        </div>
        {(isCommercialList || trialType === 'commercial') && (
          <div className="text-center" style={{ marginTop: '20px' }}>
            <p className="text-muted">For pricing, please contact us.</p>
            <button className="btn-gradient-blue">
              <a href="/book-a-demo?utm_source=web" target="_blank" className="text-white" rel="noreferrer">
                Schedule a demo
              </a>
            </button>
          </div>
        )}
      </div>

      <Modal
        isOpen={showLoginModal}
        onRequestClose={() => setShowLoginModal(false)}
        ariaHideApp={false}
        style={customStyles}
        shouldFocusAfterRender={false}
      >
        <Login onLoginSuccess={handleLoginSuccess} onClose={() => setShowLoginModal(false)} />
      </Modal>

      <AcademicApplicationModal
        isOpen={showModalAcademic}
        onClose={() => setShowModalAcademic(false)}
        onSubmit={submitAcademicApplication}
        academicStatus={academicStatus}
      />
    </React.Fragment>
  );
}

export default PricingTablesAcademic;
